import { Row } from "@commonlibs";
import styled, { css } from "styled-components";
import { getTypographyStyle } from "ui/config/theme/GlobalStyles/components/util/getTypographyStyle";
import { FormGridInputRootProps } from "./FormGridInput.types";

export const FormGridInputRoot = styled(Row)<FormGridInputRootProps>(
    ({ theme, bold }) => css`
        padding: ${theme.spacing.all(4, 5)};
        flex: 1;
        align-items: center;

        ${theme.breakpoints.down("mobile")} {
            .single-image-upload {
                justify-content: center;
            }
        }

        .TextArea,
        .TextField {
            width: 100%;
            place-self: unset;
        }

        .TextInput.TextInput.TextInput {
            border: none;
            background-color: transparent;
            padding: 0;
            textarea,
            input {
                padding: 0;
            }
        }

        .FormControl {
            .TextInput.TextInput.TextInput {
                input,
                textarea {
                    ${getTypographyStyle(bold ? "body2Strong" : "body2Light")};
                    color: ${theme.palette.text};
     
            }
        }
    `,
);
